(() => {
  if (customElements.get('yq-sidebar-toolbar')) return;

  class YqSidebarToolbar extends HTMLElement {
    connectedCallback() {
      this._controller?.abort();
      this._controller = new AbortController();
      this.addEventListener('click', this._openPanel, { signal: this._controller.signal });
    }

    disconnectedCallback() {
      this._controller?.abort();
    }

    async _openPanel(event) {
      const link = event.target.closest('[data-yq-sidebar-open]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = document.getElementById(link.dataset.yqSidebarOpen);
      if (typeof target?.show !== 'function') return;

      event.preventDefault();
      const sidebar = this.closest('header-sidebar');
      // The next panel takes focus; do not restore it to the old menu trigger.
      if (sidebar?.open) sidebar.focusTrap?.deactivate({ returnFocus: false, onDeactivate: () => {} });
      if (typeof sidebar?.hide === 'function') await sidebar.hide();
      target.show();
    }
  }

  customElements.define('yq-sidebar-toolbar', YqSidebarToolbar);
})();
